import { CloseOutlined} from "@ant-design/icons";
import { Avatar} from "antd";
import { Col, Modal, Row } from "reactstrap";
import "react-toastify/dist/ReactToastify.css";
import "../utils/detail.css";
import CardImageItem from "../../../../common/image/cardImage";
import logoBlack from "../../../../assets/images/blackPaxity.png";
const DetailBusiness = ({ modal, setModal, toggle, selectedMerchent, currentuser }) => {
const { fisrtName, lastName, sectorName, country, description, logo, businessRegistry, apiKey, apiToken, documents = []} = selectedMerchent || {};
  return (
    <Modal
      isOpen={modal}
      toggle={toggle}
      onCancel={toggle}
      centered
      backdrop="static"
      style={{ maxWidth: "690px" }}
    >
      <div className="modal-content-custom">
        <div className="modal-header-custom">
          <div className="title-detail-modal-rapport">
            <img src={logoBlack} alt="Voir détails" style={{ width: 120,marginBottom:'10px' }} /><br/>Rapport Vérification fonds providers<br/>  
          <div className="sous-title-id-rapport">ID Rapport : A9048 </div> </div>
          <CloseOutlined className="close-btn" onClick={() => setModal(false)}/>
        </div>
        <div className="sous-title-date-rapport">Date</div>
          <div className="sous-title-dat-rapport">26 Janvier 2026</div>
       <Row>
  <div className="detail-div">
    <div className="table-container">
      <table className="recap-tables"> 
        <thead>
          <tr>
            <th className="col-small">Pays</th>
            <th className="col-small">Solde Interne</th>
            <th className="col-small">Solde Externe</th>
            <th className="col-small">Écart</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="col-small">bb</td>
            <td className="col-small">bb</td>
            <td className="texte-nud">ffNN</td>
            <td>
              ff
            </td>
          </tr>
          <tr>
            <td className="col-small">bb</td>
            <td className="col-small">bb</td>
            <td className="texte-nud">ffNN</td>
            <td>
              ff
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</Row>
      </div>
    </Modal>
  );
};

export default DetailBusiness;
